/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2016, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */
'use strict';

/**
 *
 */
angular.module('bulbApp.contentEditorModule')

.directive('videoBlock', ['$timeout','CONFIG', videoBlock]);

function videoBlock($timeout, CONFIG) {
  return {
    restrict: 'E',
    require: 'videoBlock',
    controller: 'VideoBlockController as videoBlockCtrl',
    link: function link(scope, element, attrs, videoBlockCtrl) {

      // If this is a vimeo video, wait until it is loaded, then have the videoBlock update the video size.
      if (scope.contentBlockCtrl.contentBlock.video.jspType === 'VIMEO') {
        var unbindWatcher = scope.$watch(function() {
          // Watching for the iframe element to be created:
          return element.find('iframe').length;
        }, function(newLength, oldLength) {
          if (newLength !== oldLength && newLength > 0) {
            unbindWatcher();
            // Now that the iframe Element is created, we can hook up the vimeo api helper to the iframe
            // element:
            videoBlockCtrl.vimeoPlayer = new Vimeo.Player(element.find('iframe')[0]); //jshint ignore:line
            //The JS API library no longer requires you to wait for the ready event to begin using the
            // player, so the ready handler can be completely removed. However with that said, to emulate the
            // exact functionality that was used to have, I am including the new ready event that now returns
            // A promise.
            // Wait till the vimeo video is completly loaded before updating specs:
            videoBlockCtrl.vimeoPlayer.ready().then(function() {
              // Now that the video is loaded, we can update the videoBlock video size.
              videoBlockCtrl.updateVideoSize();
            });
          }
        });
      }
    },
    templateUrl: 'ajs/components/contenteditor/videoblock.html'
  };
}
